<template>
  <b-dropdown
    id="cc-product-categories-dropdown"
    :text="displaySelectedCategory.label"
    toggle-class="shadow-none border-0 py-2 px-4 text-left position-relative"
    menu-class="p-0 mt-2"
    class="w-100">
    <template v-if="loading.categories">
      <b-dropdown-item>Loading...</b-dropdown-item>
    </template>
    <template v-else>
      <b-dropdown-item
        v-for="(category, index) in categories"
        :key="`product-category-${category.label}-${index}`"
        class="py-2 px-3 d-flex align-items-center justify-content-between d-inline-block"
        :title="category.label"
        @click="setSelectedCategory(category.value)">
        {{ category.label }}
      </b-dropdown-item>
    </template>
  </b-dropdown>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      selectedCategory: "conversationalCommerce/selectedCategory",
      categories: "conversationalCommerce/categories",
      selectedBrand: "conversationalCommerce/selectedBrand",
      loading: "conversationalCommerce/loading"
    }),
    displaySelectedCategory: {
      get() {
        return this.categories.find(category => category.value === this.selectedCategory);
      },
      set(category) {
        return category;
      }
    }
  },
  methods: {
    setSelectedCategory(value) {
      this.$store.commit("conversationalCommerce/setSelectedCategory", value);
    }
  },
  watch: {
    selectedBrand() {
      this.$store.dispatch("conversationalCommerce/getBrandCategories");
    },
    selectedCategory() {
      this.$store.dispatch("conversationalCommerce/getBranchProducts");
    }
  }
}
</script>

<style lang="scss">
#cc-product-categories-dropdown {
  .dropdown-toggle {
    background-color: #F6F9FC;
    font-size: 16px;
    font-family: MainFontBold, sans-serif;
    font-weight: normal;
    color: #49545C;
    min-width: 150px;
    border-radius: 44px;
    &::after {
      position: absolute;
      border: 0;
      width: 9px;
      height: 6px;
      background: url('~@/assets/images/caret-down.svg') no-repeat center;
      bottom: 15px;
      right: 15px;
    }
  }
  .dropdown-menu {
    width: 100%;
    max-height: 300px;
    overflow-y: auto;
    background: #fff;
    .dropdown-item {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

</style>